<template>
	<div v-if="user">
		<section v-if="destinations.length" class="notifications">
			<h2>{{ $t('noun.notifications') }}</h2>
			<div class="phi-card">
				<div
					v-for="destination in destinations"
				> 
					<div style="display: block;" class="phi-media" @click="destination.drawerIsOpen = !destination.drawerIsOpen"> 
						<div class="preference "  style="display: flex;">
							<mu-icon class="phi-media-figure"
							:value="destination.drawerIsOpen ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
							></mu-icon>
							<div class="phi-media-body">{{destination.transport == 'gcm' || destination.transport == 'apn'  ? 	$t('noun.mobileApp'): destination.transport == 'email' ? $t('noun.email'):destination.transport}}
							</div>
						
							<mu-switch class="phi-media-right" :value="destination.isEnabled == '1'" @change="toggleDestination(destination)"></mu-switch> 

							<div class="phi-media-right" style="margin-left:5px" @click="destination.drawerIsOpen = !destination.drawerIsOpen">
								
								<select :id="destination.id" :v-model="destination.id" @change="putScheduleDestination(destination)">
									<option value="" selected="selected">{{$t('noun.righNow')}}</option>
									<option v-for="time in scheduleHours" :value="time.value" :selected="destination.schedule == time.value 
									? true : false">{{time.label}}</option>
								</select>
							</div>

						</div>
						
						<div v-if="destination.transport != 'gcm'" style="margin-left:2em;" >
									<small>{{destination.destination ? '('+ destination.destination +')' : '('+$t('noun.defaultValue')+')' }}</small>
						</div>
					</div>

					<phi-drawer :open="destination.drawerIsOpen">
						<div v-for="preference in destination.preferences" class="preference phi-media" :class="{disabled: destination.isEnabled != '1'}">
							<div class="phi-media-body">{{preference.type}}</div>


							<mu-switch class="phi-media-right" :value="preference.isEnabled == '1'" @change="togglePreference(preference, destination)"></mu-switch>

							<div class="phi-media-right" style="margin-left:5px">
								<!-- <i class="phi-media-right phi-media-figure mu-icon material-icons" style="margin-right: 0px !important; float:left;">		schedule
								</i> -->
								<select  :id="preference.type"  :v-model="preference.type" @change="putSchedulePreference(preference, destination)">
									<option value="" selected="selected">{{$t('noun.righNow')}}</option>
									<option v-for="time in scheduleHours" :value="time.value" :selected="preference.schedule == time.value 
									? true : false">{{time.label}}</option>
								</select>
							</div>
						</div>
						<div class="phi-media" v-if="destination.destination">
							<div class="phi-media-body" style="margin-left: 1px;">{{$t('noun.deleteEmail')}}</div>
							<button type="button" class="phi-button danger phi-media-right" @click="removeDestination(destination.id)"><span>{{$t('action.delete')}}</span></button>
						</div>
					</phi-drawer>
				</div>
				<!-- agregar email -->
				<div >
					<div class="preference phi-media" @click="isOpen = !isOpen">
						<mu-icon class="phi-media-figure" :value="isOpen ? 'remove' : 'add'"></mu-icon>
						<div class="phi-media-body">{{$t('noun.addEmail')}}</div>
					</div>
					<phi-drawer :open="isOpen" style="padding: 20px 0px 15px 10px; "> 
						<div class="phi-media" id="inputEmail">
							<phi-input class="phi-media-body" :label="$t(message)"  v-model="dataEmail" style="padding: 0px 10px 0px 0px;     width: 90% !important; " @input="validationDestination()" ></phi-input>
							<button type="button" class="phi-button  phi-media-right" @click="addDestination()"><span>{{$t('action.add')}}</span></button>
						</div>
					</phi-drawer>
				</div>

			</div>
		</section>
	</div>
</template>

<script>
import app from '../../store/app.js';
export default {
	name: "phi-destionation-notifications",
	props: ['user'],
	data() {
		return {
			app,
			destinations: [],
			isOpen: false,
			dataEmail: null,
			message: 'noun.email',
			sleep:0,
			return_validation:false,
			scheduleHours:[]
		}
	},
	
	methods:{
		loadDestinations(){
			app.api
			.get('types/post')
			.then(types => {
				app.api
					.collection(`people/${this.user}/notification/destinations`)
					.fetch()
					.then(destinations => {
						this.destinations = destinations.map(destination => {

								var setPreferences = destination.preferences;
								destination.preferences = [];
								types.forEach(type => {
									var MyIsEnabled = 1;
									//console.log(type);
									var pref = setPreferences.find(function(item){
  										return item.type == type.singular
									});

									if(setPreferences.length > 0 && (pref != null || typeof pref != 'undefined')){
										MyIsEnabled = pref.isEnabled;
									}
										destination.preferences.push({
											destination: destination.id,
											type:        type.singular,
											isEnabled:   MyIsEnabled,
											schedule:    null
										});
								});

							destination.drawerIsOpen = false;
							return destination;
						});
					});
			});
		},

		
		getScheduleHours() {
			var tmp_scheduleHours = [];

            for (var hour = 5; hour <= 23; hour++) {
                var hour12 = hour > 12 ? hour-12 : hour;
                var ampm   = hour > 12 ? 'pm' : 'am';

                tmp_scheduleHours.push(

                {
                    label: hour12 + ':00 ' + ampm,
                    value: hour + '00'
                }, {
                    label: hour12 + ':30 ' + ampm,
                    value: hour + '30'
                });
            }

			this.scheduleHours = tmp_scheduleHours;

		},

		toggleDestination(destination) {
			destination.isEnabled = destination.isEnabled == "1" ? "0" : "1";
			app.api.put(`people/${this.user}/notification/destinations/${destination.id}`, {
				isEnabled: destination.isEnabled
			});
		},

		togglePreference(preference, destination) {
			preference.isEnabled = preference.isEnabled == "1" ? "0" : "1";
			app.api.put(`people/${this.user}/notification/destinations/${destination.id}`, {
				preferences: destination.preferences
			});
		},

		putScheduleDestination(destination) {
			var element = document.getElementById(destination.id);
			//console.log(element.value);
			destination.schedule=element.value;
			app.api.put(`people/${this.user}/notification/destinations/${destination.id}`, {
				schedule: destination.schedule
			});

		},

		putSchedulePreference(preference, destination) {
			var element = document.getElementById(preference.type);
			//console.log(element.value);
			preference.schedule=element.value;
			app.api.put(`people/${this.user}/notification/destinations/${destination.id}`, {
				preferences: destination.preferences
			});
		},

		removeDestination(id){
 	  		app.api.delete(`people/${this.user}/notification/destinations/${id}`).then(() => {
				this.loadDestinations();
			});
		},

		validationDestination(){
				
				
				clearTimeout(this.sleep);
				this.sleep = setTimeout(()=>{

					var  validationEmail = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
					var element = document.getElementById("inputEmail");
					
		    			
					if(this.dataEmail == '' || this.dataEmail == null){
						this.message = 'noun.email';
						element.classList.remove("error");
						this.return_validation=false;
					}
					else if(!validationEmail.test(this.dataEmail)){
						this.message = 'noun.validEmail';
						element.classList.add("error");
						this.return_validation=false;
						
					}
					else{
						this.message = 'noun.email';
						element.classList.remove("error");
						this.return_validation = true;
					
					}
				
					
				},1000);

				return this.return_validation;
				
			
		},
		addDestination(){
			if (this.validationDestination()){
			
				app.api.post(`people/${this.user}/notification/destinations`, {
					destination:this.dataEmail,
					isEnabled: true,
					schedule :null,
					transport:'email'}
				).then(createdRecord => {
					this.dataEmail = '';
					this.isOpen = !this.isOpen;
					this.loadDestinations();
	 			});
			}
		}
	},
	mounted() {

		this.loadDestinations();
		this.getScheduleHours();
		
	}
}
	
</script>


<style lang="scss">


.error input,
.error label
{
	color: #df3e3e !important;

}
.state-phi-settings {
	section {
		margin-bottom: 2em;

		h2 {
			font-weight: 1em;
			text-transform: uppercase;
			color: #666;
			margin-bottom: 0.5em;
			font-size: 0.8em;
		}

		.disabled.preference {
			.mu-switch {
				pointer-events: none;
				opacity: .7;
			}

			.mu-switch input + .mu-switch-wrapper .mu-switch-thumb {
				background-color: #eee;
			}
		}

		.phi-media {
			cursor: pointer;
			&:hover {
				background-color: rgba(0,0,0,.04);
			}

			.phi-media-body {
				align-self: center;
			}

			.phi-media-figure {
				align-self: center;
				text-align: center;
			}
		}

		


		
	}
}
</style>
